import { Box, Text } from '@wix/design-system';
import React, { FC } from 'react';

import Typewriter from '../Typewriter/Typewriter';
import { AssistantAvatar } from './AssistantAvatar';
import { botAvatarDataHooks } from './BotAvatar.dataHooks';

type BotAvatarAIProps = {
  isLoading: boolean; // Enables AI icon animation
  text: string;
};

export const BotAvatarAI: FC<BotAvatarAIProps> = ({ isLoading, text }) => {
  return (
    <Box dataHook={botAvatarDataHooks.botAvatar()} gap="0.5" verticalAlign="middle">
      <Box>
        <AssistantAvatar animated={isLoading} />
      </Box>
      <Text size="small" secondary>
        {isLoading ? <Typewriter text={text} /> : text}
      </Text>
    </Box>
  );
};
